import React, { useEffect, useState } from 'react';
import '../UploadForm.css';
import UploadHeroImage from '../../assets/images/hero1a.jpg';

function UploadHero() {
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const shrinkRangePx = 150;
    const minimumScale = 0.65;

    const handleScroll = () => {
      const scrollY = window.scrollY;
      const newScale = Math.max(minimumScale, 1 - scrollY / shrinkRangePx);
      setScale(newScale);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="upload-hero" style={{ transform: `scale(${scale})` }}>
      <img src={UploadHeroImage} alt="hero banner with people working" />
    </div>
  );
}

export default UploadHero;


